exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".forum-post, .forum-comment {\n  padding: 1.5rem 1rem;\n  border-bottom: 1px solid #d1d6db; }\n  .forum-post .col-md-8, .forum-comment .col-md-8 {\n    min-height: 5rem; }\n  .forum-post .title, .forum-comment .title {\n    font-weight: bold;\n    font-size: 150%;\n    margin-bottom: 1rem; }\n  .forum-post .author-img, .forum-comment .author-img {\n    display: inline-block;\n    width: 30%;\n    padding-right: 0.25rem; }\n  .forum-post .post-meta, .forum-comment .post-meta {\n    display: inline-block;\n    vertical-align: top; }\n  .forum-post .post-actions, .forum-post .comment-actions, .forum-comment .post-actions, .forum-comment .comment-actions {\n    position: absolute;\n    bottom: 0; }\n\n.forum-comment .title {\n  font-size: 125%;\n  color: #898a8e; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/forums/show-post/show-post.component.scss
// module id = 398
// module chunks = 0